/*
 * Confidential and Proprietary.
 * Do not distribute without 1-800-Flowers.com, Inc. consent.
 * Copyright 1-800-Flowers.com, Inc. 2019. All rights reserved.
 */

import axios from 'axios';
import mbpUtil from '@api-util/mbp';

const getBaseUrl = () => mbpUtil.getEnv('APP_LOQATE_BASE_URL') || 'https://api.addressy.com';
const getApiKey = () => mbpUtil.getEnv('APP_LOQATE_API_KEY') || '';

const loqateRequest = (url, params = {}) => axios({
    method: 'get',
    url: `${getBaseUrl()}${url}`,
    params: {
        Key: getApiKey(),
        ...params,
    },
});

export const findLoqateAddress = (params = {}) => loqateRequest('/Capture/Interactive/Find/v1.20/json6.ws', params);

export const retrieveLoqateAddress = (params = {}) => loqateRequest('/Capture/Interactive/Retrieve/v1.30/json6.ws', params);
